import React, { useEffect, useState } from 'react';
import { useServices } from '../../hooks/useServices';
import { useHistory } from 'react-router-dom';
import { useEventos } from '../../hooks/useEventos';

export const Elije = ({lic}) => {

    const { getCODI } = useServices();
 
	const [codi, setCodi] = useState(false);
    const history = useHistory();

    const { clicPagoRecargas } = useEventos();

    const handleClick2 = () => {
        if(codi){
           lic.singlePaymentMethod = "01"; 
        }
        clicPagoRecargas('tarjeta');
     history.push("/conexionpago", {paymentSelfServiceRequest: lic});
          //console.log('objeto lic enviado: ', lic);
    }
  
    const handleClick3 = () => {
        if(codi){
            lic.singlePaymentMethod = "02"; 
        }
        clicPagoRecargas('codi');
      history.push("/conexionpago", {paymentSelfServiceRequest: lic});
         // console.log('objeto lic enviado: ', lic);
    }
  
      async function verBotonCodi(){
          let cod;
          const {value} = await getCODI(7);//7 es CODI ATT 8 es CODI UNEFON
          if(value == "0"){//0 es desactivado 1 es activado
              setCodi(false);
          }else{
              setCodi(true);
          }
      }
  
   


      useEffect(() => {
        verBotonCodi();
       
      }, [lic])
      
  


  return (
    
    <div className="botonera2">
	        
        
            <div onClick={handleClick2} className="btnpagolineaRecarga" >
                Paga en línea
                <div className="icoLineaRecarga"></div>
            </div>	
        
        { codi && 
        <>
            <div onClick={handleClick3} className="btnpagolineaRecarga2" >
            Paga con CODI
            <div className="icoQRRecarga"></div>
            </div>	
        </>
        }
   </div>
  )
}
